import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { Translate } from 'react-jhipster';
import { getParent, updateStatusParent } from './parent.reducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParentStatutModal = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const parent = useAppSelector(state => state.parent.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const id_ = props.match.params.id;
  useEffect(() => {
    dispatch(getParent(props.match.params.id));
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/parent/${currentEcole && currentEcole.id}/${id_}/details`);
  };

  const confirmUpdate = event => {
    const entity = {
      id: props.match.params.id,
      activated: parent.user.activated,
    };
    dispatch(updateStatusParent(entity));
    handleClose(event);
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <>
      <Modal
        title="Confirmation de changement du statut du parent"
        centered
        footer={[
          <Button key="back" onClick={goBack}>
            Annuler
          </Button>,
          <Button key="submit" style={{ backgroundColor: '#cd201f', color: 'white' }} onClick={confirmUpdate}>
            Modifier
          </Button>,
        ]}
        visible={true}
        closable={false}
      >
        Etes-vous certain de vouloir changer le statut du parent {parent.user.firstName} {parent.user.lastName}?
      </Modal>
    </>
  );
};

export default ParentStatutModal;
